var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectBranchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.951,
    height: 36,
    viewBox: "0 0 34.951 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M5.042-96h-15.75a3.375,3.375,0,0,0-3.375,3.375v6.75a1.125,1.125,0,0,0,1.125,1.125,1.125,1.125,0,0,0,1.125-1.125v-6.75a1.125,1.125,0,0,1,1.125-1.125H5.042a1.125,1.125,0,0,1,1.125,1.125V-62.25h-4.5v-7.875A1.125,1.125,0,0,0,.542-71.25h-6.75a1.125,1.125,0,0,0-1.125,1.125v7.875h-3.375a1.125,1.125,0,0,0-1.125,1.125A1.125,1.125,0,0,0-10.708-60H8.417V-92.625A3.375,3.375,0,0,0,5.042-96ZM-5.083-62.25V-69h4.5v6.75Zm0-22.5h-4.5v-4.5h4.5Zm9,0h-4.5v-4.5h4.5Zm-4.5,4.5h4.5v4.5h-4.5Zm-8.449,4.5h3.949v-4.5h-4.5v3.434a9.051,9.051,0,0,0-1.453-1.98,9.1,9.1,0,0,0-12.843,0,9.1,9.1,0,0,0,0,12.843l5.625,5.625a1.125,1.125,0,0,0,.8.328,1.125,1.125,0,0,0,.8-.329l5.625-5.625A9.092,9.092,0,0,0-9.032-75.75Zm-8.426,13.034-4.829-4.831a6.833,6.833,0,0,1,0-9.657,6.8,6.8,0,0,1,4.828-2,6.8,6.8,0,0,1,4.829,2,6.833,6.833,0,0,1,0,9.657Zm3.375-9.659A3.375,3.375,0,0,1-17.458-69a3.375,3.375,0,0,1-3.375-3.375,3.375,3.375,0,0,1,3.375-3.375A3.375,3.375,0,0,1-14.083-72.375Z",
    transform: "translate(26.534 96)",
    fill: "#081831"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectBranchIcon);
export default __webpack_public_path__ + "static/media/selectBranchIcon.68fabcab5345b4efb5eac5b7828deffd.svg";
export { ForwardRef as ReactComponent };